import AppLayoutContext, { ElementPosition } from 'contexts/AppLayoutContext'
import { MutableRefObject, RefObject, useCallback, useContext, useEffect, useId } from 'react'
import { ElementBoundingClientRectObserver, useElementBoundingClientRectObserver } from './useElementSize'

export function useAppHeaderObserver<T extends HTMLElement>(
  observedRef: RefObject<T> | MutableRefObject<T>,
  /** @default static */
  position: ElementPosition = 'static',
) {
  const appLayoutHandler = useContext(AppLayoutContext)
  const elementKey = useId()
  const rectObserver = useCallback<ElementBoundingClientRectObserver>((rect) => {
    appLayoutHandler('header', elementKey, rect, position)
  }, [appLayoutHandler, position, elementKey])
  useElementBoundingClientRectObserver(observedRef, rectObserver)

  useEffect(() => {
    appLayoutHandler('header', elementKey, observedRef.current?.getBoundingClientRect(), position)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, observedRef])

  useEffect(() => {
    return () => {
      appLayoutHandler('header', elementKey, undefined, 'hidden')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export function useAppFooterObserver<T extends HTMLElement>(
  observedRef: RefObject<T> | MutableRefObject<T>,
  /** @default static */
  position: ElementPosition = 'static',
) {
  const appLayoutHandler = useContext(AppLayoutContext)
  const elementKey = useId()
  const rectObserver = useCallback<ElementBoundingClientRectObserver>((rect) => {
    appLayoutHandler('footer', elementKey, rect, position)
  }, [appLayoutHandler, position, elementKey])
  useElementBoundingClientRectObserver(observedRef, rectObserver)

  useEffect(() => {
    appLayoutHandler('footer', elementKey, observedRef.current?.getBoundingClientRect(), position)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position, elementKey, observedRef])

  useEffect(() => {
    return () => {
      appLayoutHandler('footer', elementKey, undefined, 'hidden')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
